import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { ThumbsUp, ThumbsDown } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FeedbackButtons = ({ targetType, targetId, size = 'sm' }) => {
  const { getAuthHeaders } = useAuth();
  const [rating, setRating] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleFeedback = async (value) => {
    if (submitted) return;
    setRating(value);
    setSubmitted(true);
    try {
      await axios.post(`${API}/feedback`, {
        target_type: targetType,
        target_id: targetId,
        rating: value,
      }, { headers: getAuthHeaders() });
    } catch {
      setSubmitted(false);
      setRating(null);
    }
  };

  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const btnSize = size === 'sm' ? 'p-1' : 'p-1.5';

  return (
    <div className="inline-flex items-center gap-0.5" data-testid={`feedback-${targetType}-${targetId}`}>
      <button
        onClick={() => handleFeedback('up')}
        disabled={submitted}
        className={`${btnSize} rounded-md transition-all ${
          rating === 'up'
            ? 'text-emerald-600 bg-emerald-50'
            : 'text-[var(--color-muted)] hover:text-emerald-600 hover:bg-emerald-50'
        }`}
        data-testid={`feedback-up-${targetId}`}
        title="Good output"
      >
        <ThumbsUp className={iconSize} />
      </button>
      <button
        onClick={() => handleFeedback('down')}
        disabled={submitted}
        className={`${btnSize} rounded-md transition-all ${
          rating === 'down'
            ? 'text-red-500 bg-red-50'
            : 'text-[var(--color-muted)] hover:text-red-500 hover:bg-red-50'
        }`}
        data-testid={`feedback-down-${targetId}`}
        title="Needs improvement"
      >
        <ThumbsDown className={iconSize} />
      </button>
    </div>
  );
};

export default FeedbackButtons;
